import {
  Box,
  LinearProgress,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';

const FIRST_LOADING_TEXT = 'Checking transactions…';
const SECOND_LOADING_TEXT = 'Reviewing compliance…';
const THIRD_LOADING_TEXT = 'Organizing documents…';

export const LoadingSkeleton = () => {
  const [loadingText, setLoadingText] = useState(FIRST_LOADING_TEXT);

  function updateText() {
    setLoadingText((currentText) =>
      currentText === FIRST_LOADING_TEXT
        ? SECOND_LOADING_TEXT
        : THIRD_LOADING_TEXT,
    );
  }

  useEffect(() => {
    const intervalId = setInterval(updateText, 2000);

    return () => clearInterval(intervalId);
  });

  return (
    <Box
      sx={{
        height: 236,
      }}
    >
      <Skeleton
        variant="rectangular"
        sx={{
          borderRadius: 4,
          my: 2,
          height: '100%',
          position: 'relative',
        }}
      />
      <Stack
        sx={{
          alignItems: 'center',
          gap: 2,
          position: 'relative',
          top: -150,
        }}
      >
        <LinearProgress color="secondary" sx={{ width: '40%' }} />
        <Typography sx={{ color: 'text.secondary' }}>{loadingText}</Typography>
      </Stack>
    </Box>
  );
};
